import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { siteInfo } from '../config/theme';

const SEO = ({ title, description, keywords, canonical, image }) => {
  const siteUrl = 'https://srikrishcivilsupplier.com';
  const { pathname } = useLocation();
  const defaultImage = `${siteUrl}/skc_logo.webp`;
  const canonicalUrl = canonical || `${siteUrl}${pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteInfo.companyName} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image || defaultImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content={siteInfo.companyName} />
      <meta name="geo.region" content="IN-TN" />
      <meta name="geo.placename" content="Coimbatore" />

      {/* Schema.org LocalBusiness */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": siteInfo.companyName,
          "description": siteInfo.description,
          "telephone": siteInfo.phone,
          "email": siteInfo.email,
          "url": siteUrl,
          "logo": `${siteUrl}/skc_logo.webp`,
          "image": `${siteUrl}/skc_logo.webp`,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Coimbatore",
            "addressRegion": "Tamil Nadu",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "11.0168",
            "longitude": "76.9558"
          },
          "priceRange": "₹₹",
          "sameAs": [
            siteUrl,
            siteInfo.social.instagram,
            siteInfo.social.youtube,
            siteInfo.social.facebook
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
